<script lang="ts">
  export let backgroundColour: string | undefined = undefined;
  export let textColour: string | undefined = undefined;
  export let bannerText: string;
  export let linkText: string | undefined = '';
  export let linkUrl: string | undefined = '';
  $: hasLink = linkText && linkUrl;
</script>

<div
  class="flex flex-wrap items-center justify-center gap-x-2 overflow-hidden px-4 py-2.5 sm:px-3.5"
  style="background: {backgroundColour};"
>
  <p class="text-sm" style="color: {textColour};">{bannerText}</p>
  {#if hasLink}
    <a
      class="text-sm underline font-semibold plausible-event-name=banner_CTA_{linkText
        ?.split(' ')
        .join('_')}"
      style="color: {textColour};"
      href={linkUrl}>{linkText}</a
    >
  {/if}
</div>
